export const defaultPageStateConfig = {page:1}